import { createApp } from "vue";
import VueCookies from "vue3-cookies";
import App from "./App.vue";
import router from "./router/index.js";
import "./assets/tailwind.css";
import "./assets/editor.css";
import LitepieDatepicker from "litepie-datepicker";
import { createPinia } from 'pinia';

const SW_HOSTS = ['cn.patensys.com', 'cndev.patensys.com'];

if ('serviceWorker' in navigator && SW_HOSTS.includes(window.location.hostname))
{
  navigator.serviceWorker.register('/sw.js').then(registration => {
    console.log('Service worker registered:', registration); 
  }).catch(error => { 
    console.error('Service worker registration failed:', error); 
  });

}

createApp(App)
  .use(router)
  .use(VueCookies)
  .use(LitepieDatepicker)
  .use(createPinia())
  .mount("#app");
